import * as React from "react";
import {useContext, useEffect, useMemo, useState} from "react";
import {useTranslation} from "react-i18next";
import {useRecoilValue} from "recoil";
import {profileList} from "../state/profileState";
import {Box} from "@mui/system";
import AgGridCustomTable from "../../../util/component/AgGridCustomTable";
import {GlobalContext} from "../../../util/state/GlobalContextProvider";
import {ColDef, ICellRendererParams} from "ag-grid-community";
import {IconButton, Tooltip} from "@mui/material";
import i18n from "i18next";
import {useNavigate} from "react-router-dom";
import Stack from "@mui/material/Stack";
import {DescriptionRounded, EditRounded} from "@mui/icons-material";

const ProfileTable = () => {
    const {t} = useTranslation(['operator']);
    const {globalData} = useContext(GlobalContext);
    const profiles = useRecoilValue(profileList);
    const navigate = useNavigate();
    const defColDefs = [
        {field: 'name', headerName: t('label.name')},
        {
            field: 'department.name', headerName: t('label.department'),
            cellRenderer: (params: ICellRendererParams) => t('translation:departments.'.concat(params.value))
        },
        {
            field: "_actions",
            headerName: '',
            sortable: false,
            cellRenderer: (params: any) => {
                return (
                    <Stack direction={"row"} justifyContent={"center"}>
                        <IconButton color="accent"
                                    onClick={() => {
                                        window.open( `${window.location.origin}/operator/profile/list/${params.data.id}`);
                                    }}>
                            <DescriptionRounded/>
                        </IconButton>
                    </Stack>
                );
            }
        }
    ];
    const [columnDefs, setColumnDefs] = useState<ColDef[]>(defColDefs);

    const defaultColDef = useMemo(() => {
        return {
            sortable: true,
            minWidth: 150,
        }
    }, []);

    useEffect(() => {
        if (globalData.user?.legalEntities.length > 1 && !columnDefs.find(c => c.field === 'legalEntities')) {
            setColumnDefs(prevState => {
                return [
                    ...defColDefs.slice(0, defColDefs.length - 1),
                    {
                        field: 'legalEntities',
                        headerName: t('label.legalEntity'),
                        cellRenderer: (params: ICellRendererParams) => {
                            let result: string[] = [];
                            if (params.value) {
                                params.value.forEach((legalEntity: any) => {
                                    result.push(legalEntity.name);
                                });
                            } else {
                                result = ['---'];
                            }
                            return result.length > 1 ? <Tooltip arrow title={result.join(", ")}>
                                <div>{result[0] + ' ...'}</div>
                            </Tooltip> : result[0];
                        }
                    },
                    ...defColDefs.slice(defColDefs.length - 1, defColDefs.length),
                ]
            });
        } else {
            setColumnDefs(defColDefs);
        }
    }, [t]);

    return (
        <Box>
            <AgGridCustomTable
                rowData={profiles}
                columnDefs={columnDefs}
                gridOptions={
                    {
                        defaultColDef: defaultColDef,
                    }
                }
            />
        </Box>
    );
}
export default ProfileTable;
